import React from 'react';
import ModalConfirm from './ModalConfirm';
 
const ModalConfirmDeleteCase = (props) => {
  const message = 'Are you sure you want to archive this case?';

  return (
    <ModalConfirm
      message={message}
      onConfirm={props.props.onConfirm}
      onClose={props.onClose}
    />
  );
};

export default ModalConfirmDeleteCase;